import * as yup from 'yup';
import translation from 'i18n/translation.json';

export const usePromocodeSchema = () => {
  const schema = yup.object({
    promocode: yup.string().required(() => {
      return translation.errors.requiredField;
    }),
  });

  return { schema };
};
